import React, { useState, useEffect } from "react";
import throttle from "lodash/throttle";
import { Router } from "react-router-dom";

import "./App.css";
import "antd/dist/antd.css";
import "./assets/styles/main.scss";
import "./assets/styles/global.scss";

import { BackTop } from "antd";
import { history } from "./store";

import AppRouter from "./AppRouter";
import AppNavComponent from "./components/AppNav/";
import AppFooterComponent from "./components/AppFooter/";

import { useSelector, useDispatch } from "react-redux";

import $ from "jquery";
import { getMembershipInfo, loadCart } from "./actions/sandos4UAction";
import { globalActions } from "./actions/globalActions";
import { getLanguage } from './selectors/global';
import { completeDatePickerLocale } from './helpers/datepicker-lang';
import CookieLaw from "./components/CookieLaw";
import BookingFormComponent from "./components/BookingForm/BookingFormComponent";
import {getQueryStringValue} from "./services/global";
import {userActions} from "./actions/authenticationActions";
import SimpleHomeContainer from './containers/SimpleHomeContainer';

window.jQuery = $;
window.$ = $;
global.jQuery = $;


const initialLoad = (brandId, brand, authToken, locale, cart, loy3MembershipInfo) => (dispatch) => {
  if (brandId) {
    globalActions.setTheme(brandId)(dispatch);
  } else {
    globalActions.getBrandId()(dispatch);
  }

  // If we have brand id but not brand details, or the brand id is distinct to stored in the
  // brand details, we need to retrieve again the details.
  if ((brandId && !brand) || (brandId && brand && parseInt(brandId, 10) !== brand.brandId)) {
    globalActions.getBrandDetails(brandId)(dispatch);
  }

  if (authToken && brandId && locale && !cart) {
    loadCart(authToken, brandId, locale)(dispatch);
  }

  completeDatePickerLocale(locale);
}

const App = () => {
  const dispatch = useDispatch();
  const [route] = useState(null);
  const [showHeader, setShowHeader] = useState(false);

  const bookingForm = useSelector((state) => state.bookingForm.bookingForm);
  const locale = useSelector(getLanguage);
  const loginOpen = Boolean(useSelector((state) => state.modals.showingUp && state.modals.showingUp.login));

  const brandId = useSelector((state) => state.global.brandId);
  const brand = useSelector((state) => state.global.brand);

  const cart = useSelector((state) => state.sandos4U.cart);
  const loggedIn = Boolean(useSelector((state) => state.authentication.loggedIn));
  const loy3MembershipInfo = useSelector((state) => state.sandos4U.membershipUser);
  const authToken = useSelector((state) => state.authentication.authToken);
  const auth = Boolean(authToken);

  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      window.document.body.classList.add('debug-screens');
    }
    const throttledCount = throttle(setHeaderBg, 100);
    window.addEventListener('scroll', throttledCount);
    return () => window.removeEventListener('scroll', throttledCount);
  }, []);


  useEffect(() => {
    initialLoad(brandId, brand, authToken, locale, cart, loy3MembershipInfo)(dispatch);
  }, [brandId, brand, authToken, locale, cart, loy3MembershipInfo, dispatch, route]);

  // Event only when auth token change
  useEffect(() => {
    if (authToken && brandId) {
      getMembershipInfo(authToken, locale, brandId)(dispatch);
    }
  }, [authToken, locale, brandId, dispatch]);

  // Event only when change brandId
  useEffect(() => {
    const memberToken = getQueryStringValue('member_token');
    if (brandId && memberToken) {
      userActions.loginWithToken(memberToken, brandId, history)(dispatch);
    }
  }, [brandId, dispatch]);

  const setHeaderBg = () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > 100 ){
      setShowHeader(true);
    } else {
      setShowHeader(false);
    }
  }

  const isHome = (location) => location === "/";
  return (
    <div className={`main-wrapper ${!isHome(route) || showHeader ? "" : "main-wrapper--home"}`}>

      <BookingFormComponent show={bookingForm} locale={locale} key={locale} />
      <Router history={history}>
        <AppNavComponent brandDetails={brand} history={history} dispatch={dispatch}/>
        <AppRouter
          brand={brand}
          auth={auth}
          loggedIn={loggedIn}
          locale={locale}
        />
        {brand && !loginOpen && <AppFooterComponent brandDetails={brand} lang={locale} loggedIn={loggedIn} history={history} />}
      </Router>
      <BackTop />
    </div>
  );
}

export default App;
